const breakpoints = [375, 685, 1000, 1200, 1600, 500];
const mq = breakpoints.map(
  bp => `@media (max-width: ${bp}px)`
)

export {mq};